import { StoreEmployeeRequirement } from './StoreEmployeeRequirement';
import { BankingSettings } from './BankingSettings';
import { StoreClosure } from './StoreClosure';
import { StoreDefaultWorkingTime } from './StoreDefaultWorkingTime';
import { StoreSpecialWorkingTime } from './StoreSpecialWorkingTime';

/**
 * Detailed information about a store.
 */
export class StoreDetails {
  slug: string;
  name: string;
  firstEditableDate: string;
  defaultWorkingTimes: StoreDefaultWorkingTime[];
  specialWorkingTimes: StoreSpecialWorkingTime[];
  employeeRequirements: StoreEmployeeRequirement[];
  bankingSettings: BankingSettings[];
  storeClosures: StoreClosure[];

  /**
   * @param slug the identifier of the store.
   * @param name the name of the store.
   * @param firstEditableDate the earliest date, for which the input data can be edited.
   * @param defaultWorkingTimes opening and closing times for the store for each of the days of the week.
   * @param specialWorkingTimes opening and closing times for the store on specific overridden days.
   * @param employeeRequirements the minimum number of employees that needed to be present for store opening, closing, and regular
   * business hours.
   * @param bankingSettings the store requirements for banking operations.
   * @param storeClosures days on which the store is closed with associated reasons.
   */
  constructor(
    slug: string,
    name: string,
    firstEditableDate: string,
    defaultWorkingTimes: StoreDefaultWorkingTime[],
    specialWorkingTimes: StoreSpecialWorkingTime[],
    employeeRequirements: StoreEmployeeRequirement[],
    bankingSettings: BankingSettings[],
    storeClosures: StoreClosure[]
  ) {
    this.slug = slug;
    this.name = name;
    this.firstEditableDate = firstEditableDate;
    this.defaultWorkingTimes = defaultWorkingTimes;
    this.specialWorkingTimes = specialWorkingTimes;
    this.employeeRequirements = employeeRequirements;
    this.bankingSettings = bankingSettings;
    this.storeClosures = storeClosures;
  }
}

